import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import loadingWhite from "@/assets/lottie/loading.json?url"; // 흰색 4점 (dim/파란 배경 위)
import loadingBlue from "@/assets/lottie/payment-loading.json?url"; // 파란 4점 (흰 배경 위)
import styles from "./LoadingLottie.module.scss";

type LoadingLottieVariant = "white" | "blue";

type LoadingLottieProps = {
  /** 배경에 따른 색 — white(dim/파란 primary 배경) | blue(흰 배경). 기본 white. */
  variant?: LoadingLottieVariant;
  /** 정사각 래퍼 크기(rem/px 문자열). 기본 1.5rem. */
  size?: string;
  /** 래퍼 확장 클래스(선택). */
  className?: string;
};

// variant → 자산 매핑. payment-loading 파일명은 유지하되 여기서 흡수해 소비처에 결제 네이밍을 노출하지 않는다.
const LOTTIE_SRC: Record<LoadingLottieVariant, string> = {
  white: loadingWhite,
  blue: loadingBlue,
};

/**
 * 정의서 4점 로딩 로띠(흰/파랑) 공용 로더.
 * 순수 장식 — 래퍼 aria-hidden. 로딩 상태 알림(role/aria-live, srOnly 문구)은 소비처가 소유한다.
 * (LoadingBox/PaymentConfirmLoading 의 loader/loaderPlayer 래퍼 패턴 재사용)
 */
const LoadingLottie = ({ variant = "white", size = "1.5rem", className }: LoadingLottieProps) => (
  <div
    className={`${styles.loader} ${className ?? ""}`.trim()}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <DotLottieReact src={LOTTIE_SRC[variant]} autoplay loop className={styles.loaderPlayer} />
  </div>
);

export default LoadingLottie;
